import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import WorkNavbar from "../../components/WorkNavbar";
import useAnimation from "../../components/useAnimation";

const Work = () => {
  const location = useLocation();
  const isWorkPage = location.pathname === "/work";
  const isAnimating = useAnimation(1500);

  return (
    <div className="relative min-h-screen">
      <div className="fixed inset-0 bg-deep -z-10"></div>
      {isAnimating && (
        <div className="fixed inset-0 bg-lightBrown z-50 animate-slideLeft"></div>
      )}
      <div className="text-beige flex flex-col-reverse md:h-screen md:pt-[2rem] md:flex-row">
        <div className={`${isWorkPage ? "px-4 md:px-0 md:w-2/3" : "md:w-1/4"}`}>
          <WorkNavbar isWorkPage={isWorkPage} />
        </div>
        <div
          className={`${
            isWorkPage
              ? "md:flex md:items-end md:w-1/3 md:pb-[8rem] md:pr-4"
              : "md:w-3/4 md:p-4 md:overflow-y-auto"
          }`}
        >
          {isWorkPage && (
            <div className="pt-16 md:pt-16 p-4 md:fixed md:text-base md:mr-32">
              {/* desktop view overview */}
              <h1 className="hidden md:block md:mb-3 md:font-bold md:text-xl ">
                WORK.
              </h1>
              {/* mobile view work page overview */}
              <h1 className="md:hidden font-extrabold text-7xl pb-2">WORK.</h1>
              <div className="px-2 md:px-0 md:text-lg">
                <p className="md:mb-1 ">
                  This portfolio showcases my expertise across diverse areas,
                  including frontend development, responsive web design, and
                  interactive user interfaces.{" "}
                </p>
                <p>
                  The field of frontend engineering is ever-changing, driven by
                  new technologies and trends. I'm committed to continuous
                  learning and honing my skills to create seamless and engaging
                  digital experiences.
                </p>
              </div>
              {/* - - - - - - - - - - - - - - line  - - - - - - - - - - - - - -*/}
              <div className="flex items-center justify-center pt-3 md:hidden">
                <p className="font-black text-lightDeep text-xl">
                  - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                  -
                </p>
              </div>
            </div>
          )}
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default Work;
